export default function CostCalculatorSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Hero Section Skeleton */}
      <div className="py-20 bg-gray-200 animate-pulse">
        <div className="container mx-auto px-4 text-center">
          <div className="w-16 h-16 bg-gray-300 rounded mx-auto mb-6"></div>
          <div className="h-8 bg-gray-300 rounded w-96 mx-auto mb-6"></div>
          <div className="h-6 bg-gray-300 rounded w-2/3 mx-auto"></div>
        </div>
      </div>

      {/* Calculator Section Skeleton */}
      <div className="py-16">
        <div className="container mx-auto px-4">
          <div className="max-w-4xl mx-auto">
            <div className="grid md:grid-cols-2 gap-8">
              {/* Form Skeleton */}
              <div className="bg-white rounded-lg shadow p-6">
                <div className="h-6 bg-gray-200 rounded w-48 mb-4"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-8"></div>

                {/* Project Type Skeleton */}
                <div className="space-y-3 mb-6">
                  <div className="h-4 bg-gray-200 rounded w-24"></div>
                  {[1, 2, 3].map((i) => (
                    <div key={i} className="p-4 border rounded-lg">
                      <div className="flex items-center gap-3">
                        <div className="w-6 h-6 bg-gray-200 rounded"></div>
                        <div>
                          <div className="h-4 bg-gray-200 rounded w-32 mb-1"></div>
                          <div className="h-3 bg-gray-200 rounded w-16"></div>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>

                {/* Input Fields Skeleton */}
                <div className="space-y-4">
                  <div>
                    <div className="h-4 bg-gray-200 rounded w-24 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                  </div>
                  <div>
                    <div className="h-4 bg-gray-200 rounded w-32 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                  </div>
                  <div>
                    <div className="h-4 bg-gray-200 rounded w-28 mb-2"></div>
                    <div className="h-10 bg-gray-200 rounded"></div>
                  </div>
                </div>

                {/* Buttons Skeleton */}
                <div className="flex gap-3 mt-6">
                  <div className="h-11 bg-gray-200 rounded flex-1"></div>
                  <div className="h-11 bg-gray-200 rounded w-20"></div>
                </div>
              </div>

              {/* Results Skeleton */}
              <div className="bg-white rounded-lg shadow p-6">
                <div className="h-6 bg-gray-200 rounded w-40 mb-4"></div>
                <div className="h-4 bg-gray-200 rounded w-full mb-12"></div>
                <div className="text-center py-12">
                  <div className="w-16 h-16 bg-gray-200 rounded mx-auto mb-4"></div>
                  <div className="h-5 bg-gray-200 rounded w-32 mx-auto mb-2"></div>
                  <div className="h-4 bg-gray-200 rounded w-48 mx-auto"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
